import { atom } from 'jotai';

import { postSignupDefaultMessages, PostSignupMessages } from './PostSignup.messages';

export const postSignupStringsAtom = atom<PostSignupMessages>(postSignupDefaultMessages);
